import { render, staticRenderFns } from "./marketZone.vue?vue&type=template&id=887ec542&scoped=true"
import script from "./marketZone.vue?vue&type=script&lang=js"
export * from "./marketZone.vue?vue&type=script&lang=js"
import style0 from "./marketZone.vue?vue&type=style&index=0&id=887ec542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887ec542",
  null
  
)

component.options.__file = "marketZone.vue"
export default component.exports